import React from 'react';
import { statusColor, formatStatusLabel, useStatusText } from './statusPresentation';

interface StatusBadgeProps {
  value: number;
  statusType: number;
  /** Custom labels bypass API lookup — used for legacy mappings not in StatusCodes table */
  customLabels?: Record<number, string>;
}

/**
 * Enhetlig statusvisning: «kode - tekst» + farge. Tekst + farge hentes fra den delte
 * presentasjonsmodulen (statusPresentation.ts) — samme kilde overalt (Model A).
 */
export const StatusBadge: React.FC<StatusBadgeProps> = ({ value, statusType, customLabels }) => {
  // Custom labels (legacy StcTrans LineType o.l.) — ingen API-oppslag.
  const customText = customLabels ? (customLabels[value] ?? null) : undefined;
  // Hook må alltid kalles; den ignoreres når customLabels er satt.
  const lookedUp = useStatusText(statusType, value);
  const text = customLabels ? customText : lookedUp;

  const colorClasses = statusColor(statusType, value, !!customLabels);
  const displayText = formatStatusLabel(value, text);

  return (
    <span className={`inline-flex items-center whitespace-nowrap px-2 py-0.5 rounded-full text-xs font-medium ${colorClasses}`}>
      {displayText}
    </span>
  );
};
